import { errorHandlingActions } from "./error-handling-slice"

export const throwError = ({ userMessage, error, message, level, component, line }) => {
    return (dispath) => {
        dispath(errorHandlingActions.throwError({ userMessage, error: { ...error }, message, level, component, line }))
    }
}

export const throwApiError = ({ userMessage, error, statusCode, message, level, component, line, type = "error", showCancel, showTitle, confirmText, showRestore }) => {
    return (dispath) => {
        const newerror = {
            message: error.message,
            stack: error.stack,
            response: {
                error: { ...error.response?.error },
                text: error.response?.text
            }
        }

        let errorstr = ""
        try {
            errorstr = JSON.stringify(newerror)
        }
        catch (e) { }

        dispath(errorHandlingActions.throwError({ userMessage, error: errorstr, statusCode, message, level, component, line, type, showCancel, showTitle, confirmText, showRestore }))
    }
}

export const resetError = () => {
    return (dispath) => {
        dispath(errorHandlingActions.resetError(null))
    }
}